import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {
  Button, Card,
  Col,
  Divider,
  Form,
  Icon,
  Input,
  message,
  Popconfirm,
  Row,
  Select,
  Spin, Typography,
  Upload,
} from 'antd';
import {McCkEditor} from '../../../components';
import {get, patch, post} from '../../../components/mc_axios/McAxios';
import {
  arrayConcat, debounce,
  getSubjectList,
  getSystemList,
} from '../../../components/util';

const {TextArea} = Input;
const {Paragraph} = Typography;

class EditMedpixxForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      medpixxId: this.props.match.params.medpixxId,
      featuredImageUrl: '',
      featuredImageAltText: '',
      createdAt: '',
      description: '',
      subjectsList: [],
      systemsList: [],
      tagsList: [],
      fetching: false,
      reference: '',
    };
    this.confirmDelete = this.confirmDelete.bind(this);
  }

  componentDidMount() {
    getSubjectList(subjects => {
      this.setState({
        subjectsList: subjects,
      });
    });

    getSystemList(systems => {
      this.setState({
        systemsList: systems,
      });
    });

    this.getMedpixxDetailts();
  }

  getTagList = debounce( value => {
    this.setState({tagsList: [], fetching: true});
    post('/api/coordinates/coordinates/tags', {tag: value}).then(response => {
      if (response.status === 200) {
        const tempTags = response.data.data.tags ?? [];
        const uniqueTags = [...new Set(tempTags)];
        const tagsList = uniqueTags.map(tag => ({
          text: tag,
          value: tag,
        }));
        this.setState({tagsList, fetching: false});
      }
    });
  }, 1000);

  getMedpixxDetailts = () => {
    get('/api/medpixx/images/' + this.state.medpixxId).then(response => {
      let medpixxData = response.data.data.medpixx;
      let imageUrl,
          imageAltText = '';

      if (medpixxData.medpixx_image_url !== undefined) {
        imageUrl = medpixxData.medpixx_image_url;
        imageAltText = medpixxData.medpixx_image_alt_text;
      }

      let list = [];
      if (medpixxData.tags !== undefined && medpixxData.tags.length > 0) {
        let tags = medpixxData.tags;
        for (let i = 0; i < tags.length; i++) {
          list.push({
            key: tags[i],
            label: tags[i],
          });
        }
      }

      this.setState({
        featuredImageUrl: imageUrl,
        featuredImageAltText: imageAltText,
        description: medpixxData.description,
        createdAt: medpixxData.created_at,
        reference: medpixxData.reference,
      });

      this.props.form.setFieldsValue({
        title: medpixxData.title,
        subject: medpixxData.subject,
        system: medpixxData.system,
        tags: list,
        status: medpixxData.status,
        meta_title: medpixxData.meta_title,
        meta_description: medpixxData.meta_description,
        meta_keywords: medpixxData.meta_key_words,
        slug: medpixxData.slug,
        reference: medpixxData.reference,
      });
    });
  };

  fillMetaKeywords = value => {
    const {getFieldValue, setFieldsValue} = this.props.form;
    let keywords = value.map(d => d.key);
    let metaKeyWords = getFieldValue('meta_keywords') === undefined ?
        [] :
        getFieldValue('meta_keywords');
    setFieldsValue({
      meta_keywords: arrayConcat(keywords, metaKeyWords),
    });
  };

  handleSubmit = saveType => {
    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }

      const {
        medpixxId,
        featuredImageUrl,
        featuredImageAltText,
        description,
        createdAt,
        reference,
      } = this.state;

      if (featuredImageUrl === '' && values.file !== undefined) {
        values.medpixx_image_url = values.file.file.response.data.file_url;
        values.medpixx_image_alt_text = values.file.file.response.data.alt_text;
      } else {
        values.medpixx_image_url = featuredImageUrl;
        values.medpixx_image_alt_text = featuredImageAltText;
      }
      delete values['file'];
      let list = [];
      if (values.tags !== undefined) {
        let tags = values.tags;
        for (let j = 0; j < tags.length; j++) {
          list.push(tags[j].key);
        }
      }
      values.tags = list;
      values.description = description;
      values.status = parseInt(saveType);
      values.medpixx_id = medpixxId;
      values.created_at = createdAt;
      values.reference = reference;
      post('/api/medpixx/images/update', values).then(response => {
        if (response.data.status === true && response.data.code === 200) {
          const {history} = this.props;
          history.push('/dashboard/medpixx');
        } else {
          message.error('Something went wrong. Try again.');
        }
      });
    });
  };

  confirmDelete = () => {
    patch('/api/medpixx/images/delete', {
      medpixx_id: this.state.medpixxId,
    }).then(response => {
      if (response.data.status === true) {
        message.success('Medpixx deleted successfully');
        const {history} = this.props;
        history.push('/dashboard/medpixx');
      } else {
        message.error('Something went wrong');
      }
    });
  };

  handleDescriptionChange(description) {
    this.setState({
      description,
    });
  }

  render() {
    const {getFieldDecorator, getFieldValue} = this.props.form;
    const Dragger = Upload.Dragger;
    const Option = Select.Option;
    const {medpixxId, description, subjectsList, systemsList, tagsList, fetching} = this.state;
    const props = {
      name: 'file',
      action: '/api/media/upload',
      data: {
        product_type: 2,
      },
      onChange(info) {
        if (info.file.status === 'done') {
          message.success(`${info.file.name} file uploaded successfully`);
        } else if (info.file.status === 'error') {
          message.error(`${info.file.name} file upload failed.`);
        }
      },
    };

    const medPixxFullUrl = 'https://www.medcampus.io/medpixx/' +
        getFieldValue('slug') + '-' + medpixxId;

    return (
        <Form>
          <Row className="main-content-block" gutter={16}>
            <Col span={12}>
              <div className="page-header">
                <Link to={'/dashboard/medpixx/'}>
                  <Icon type="arrow-left" title={'Back'}/>
                </Link>
                <Divider type="vertical"/> Edit MedPixx
              </div>
            </Col>
            <Col span={12} className="text-right">
              <Popconfirm
                  title="Are you sure?"
                  onConfirm={this.confirmDelete}
                  onCancel={() => message.error('You have canceled the delete')}
                  okText="Yes"
                  cancelText="No"
              >
                <Button type="danger" htmlType="button" className="mc-mr-5">
                  Delete
                </Button>
              </Popconfirm>
              <Button
                  type="default"
                  htmlType="button"
                  className="mc-mr-5"
                  onClick={() => this.handleSubmit(1)}
              >
                Update
              </Button>
              <Button
                  type="primary"
                  htmlType="button"
                  onClick={() => this.handleSubmit(2)}
              >
                Update & Publish
              </Button>
            </Col>
            <Col span={24}>
              <hr className="mc-mt-10"/>
            </Col>
            <Col xs={24} lg={15}>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item label="Title">
                    {getFieldDecorator('title', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input the title!',
                        },
                      ],
                    })(
                        <Input placeholder="Enter medPixx title"
                               size={'large'}/>,
                    )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item label="Subject">
                    {getFieldDecorator('subject')(
                        <Select
                            mode="multiple"
                            placeholder="Select subject"
                            size={'large'}
                        >
                          {subjectsList.map(function(subject, index) {
                            return (
                                <Option value={subject} key={index}>
                                  {subject}
                                </Option>
                            );
                          })}
                        </Select>,
                    )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item label="System">
                    {getFieldDecorator('system')(
                        <Select
                            mode="multiple"
                            placeholder="Select system"
                            size={'large'}
                        >
                          {systemsList.map(function(system, index) {
                            return (
                                <Option value={system} key={index}>
                                  {system}
                                </Option>
                            );
                          })}
                        </Select>,
                    )}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                  <Form.Item label="Tags">
                    {getFieldDecorator('tags')(
                        <Select
                            mode="tags"
                            labelInValue
                            placeholder="Enter tags"
                            notFoundContent={fetching ?
                                <Spin size="small"/> :
                                null}
                            filterOption={true}
                            onSearch={this.getTagList}
                            onBlur={this.fillMetaKeywords}
                            size={'large'}
                        >
                          {tagsList.map(d => (
                              <Option key={d.value}>{d.text}</Option>
                          ))}
                        </Select>,
                    )}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <McCkEditor
                      content={description}
                      onMcEditorChange={evt =>
                          this.handleDescriptionChange(evt.editor.getData())
                      }
                  />
                </Col>
                <Col span={24}>
                  {this.state.featuredImageUrl === '' ? (
                      <Form.Item label="Feature Image">
                        {getFieldDecorator('file', {
                          rules: [
                            {
                              required: true,
                              message: 'Feature image is required',
                            },
                          ],
                        })(
                            <Dragger {...props}>
                              <p className="ant-upload-drag-icon">
                                <Icon type="inbox"/>
                              </p>
                              <p className="ant-upload-text">
                                Click or drag file to this area to upload
                              </p>
                              <p className="ant-upload-hint">
                                Support for a single or bulk upload. Strictly
                                prohibit
                                from uploading company data or other band files
                              </p>
                            </Dragger>,
                        )}
                      </Form.Item>
                  ) : (
                      <Row>
                        <Col span={24}>
                          <p>Feature Image:</p>
                        </Col>
                        <Col span={24}>
                          <img
                              src={this.state.featuredImageUrl}
                              style={{width: 400}}
                              alt="Img"
                          />
                        </Col>
                        <Col span={24}>
                          <Button
                              className="mc-mt-10"
                              type="primary"
                              htmlType="submit"
                              onClick={() => this.setState(
                                  {featuredImageUrl: ''})}
                          >
                            Remove
                          </Button>
                        </Col>
                      </Row>
                  )}
                </Col>
              </Row>
            </Col>

            <Col xs={24} lg={9}>
              <Row>
                <Col span={24}>
                  <p className="mc-mt-10">medPixx url:</p>
                  <Card className="mc-mb-10">
                    <Paragraph
                        className="mc-mb-0"
                        copyable
                    >{medPixxFullUrl}</Paragraph>
                  </Card>
                </Col>
                <Col span={24}>
                  <Form.Item label="Reference">
                    <McCkEditor
                        type={1}
                        content={this.state.reference}
                        onMcEditorChange={evt =>
                            this.setState({
                              reference: evt.editor.getData(),
                            })
                        }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <div className="seo-section">
                <Row gutter={16}>
                  <Col span={24}>
                    <h3>SEO</h3>
                    <hr/>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Meta Title">
                      {getFieldDecorator('meta_title', {
                        rules: [
                          {
                            required: true,
                            message: 'Please enter meta title',
                          },
                        ],
                      })(<Input placeholder="Enter meta title"
                                size={'large'}/>)}
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Slug">
                      {getFieldDecorator('slug', {
                        rules: [
                          {
                            required: true,
                            message: 'Please enter slug',
                          },
                        ],
                      })(<Input size={'large'}/>)}
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Meta Description">
                      {getFieldDecorator('meta_description', {
                        rules: [
                          {
                            required: true,
                            message: 'Please enter meta description',
                          },
                        ],
                      })(<TextArea rows={4}/>)}
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Meta Keywords">
                      {getFieldDecorator('meta_keywords', {
                        rules: [
                          {
                            required: true,
                            message: 'Please enter alteast one keyword',
                          },
                        ],
                      })(
                          <Select
                              mode="tags"
                              placeholder="Enter keywords"
                              size={'large'}
                          />,
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Form>
    );
  }
}

const EditMedpixx = withRouter(
    Form.create({name: 'edit_medpixx'})(EditMedpixxForm));

export {EditMedpixx};
